import { FC, memo, Suspense, useEffect, useState } from 'react'
import { Outlet } from '@tanstack/react-router'
import IconAccount from 'assets/person-circle.svg?react'
import cn from 'classnames'
import { ModalSidebar } from 'components/extend/Sidebar'
import { IconSpinner } from 'components/IconSpinner'
import { MainWarning } from 'components/MainWarning'
import { useNotifications, useTypedSelector } from 'hooks'
import { useIsTablet } from 'hooks/media'
import * as features from 'utils/feature'

import { Footer } from './Footer/Footer'
import Header from './Header/Header'

const MainLayout: FC = () => {
  const isTablet = useIsTablet()
  const { token } = useTypedSelector((state) => state.authReducer)

  const { refetchNotification, notificationNotViewed } = useNotifications()
  const [isModalNotifications, setIsModalNotifications] = useState(false)

  const handleOpenModalNotifications = () => {
    setIsModalNotifications(true)
  }
  const handleCloseModalNotifications = () => {
    setIsModalNotifications(false)
  }

  useEffect(() => {
    if (token) {
      refetchNotification()
    }
  }, []) // eslint-disable-line

  return (
    <div
      className={cn('flex min-h-screen w-full flex-col overflow-hidden bg-[#f0f3f7]', {
        "!bg-[url('assets/new-year-pattern.svg')]": features.newYearLogo
      })}
    >
      <MainWarning />
      <Header
        handleCloseModalNotifications={handleCloseModalNotifications}
        handleOpenModalNotifications={handleOpenModalNotifications}
        isModalNotifications={isModalNotifications}
        isTablet={isTablet}
        userInfo={<IconAccount />}
      />
      {isTablet && (
        <ModalSidebar
          handleOpenModalNotifications={handleOpenModalNotifications}
          isModalNotifications={isModalNotifications}
          notificationNotViewed={notificationNotViewed}
        />
      )}
      <div className="flex flex-grow flex-col items-center">
        <Suspense fallback={<IconSpinner size="lg" />}>
          <Outlet />
        </Suspense>
      </div>
      <Footer />
    </div>
  )
}

export default memo(MainLayout)
